export default "__VITE_ASSET__d97edb59__"